<template>
  <div class="tw-bg-gray-100 tw-px-4 tw-py-2 tw-border-t tw-border-gray-200">
    <slot />
  </div>
</template>

<script setup lang="ts">
  defineOptions({ name: 'UiCardFooter' })
</script>
